/* CheapBats 2026-09-01 — bat sizing guide ("What size do I need?").
   Sizing logic is the BatReviews Bat Genie (Mike's age-anchored length + drop norms) with a
   height/weight path for BBCOR, wood and tee ball. Renders inside snippets/cb-size-guide.liquid,
   injects the opener link beside the Size legend of the theme variant picker, and can select the
   matching size on the product. Source of truth: InventorySOT/theme_src/cb-size-guide.js */
(function () {
  'use strict';

  var CERTS = {
    bbcor:      { name: 'BBCOR',        coll: 'bbcor-bats',              mode: 'hw' },
    wood:       { name: 'Wood',         coll: 'wood-bats',               mode: 'hw' },
    usssa:      { name: 'USSSA',        coll: 'usssa-baseball-bats',     mode: 'youth' },
    usa:        { name: 'USA Baseball', coll: 'usa-baseball-bats',       mode: 'youth' },
    coachpitch: { name: 'Coach Pitch',  coll: 'coach-pitch-bats',        mode: 'youth' },
    fastpitch:  { name: 'Fastpitch',    coll: 'fastpitch-softball-bats', mode: 'youth' },
    teeball:    { name: 'Tee Ball',     coll: 'tee-ball-bats',           mode: 'tee' },
    slowpitch:  { name: 'Slowpitch',    coll: 'slowpitch-softball-bats', mode: 'sp' }
  };
  // What CheapBats slowpitch customers actually buy — order history 2026-04-14 → 2026-09-01,
  // 4,139 bats with a weight on the variant (attributed by variant_id). Half-ounce sizes
  // (25.5 / 26.5 / 27.5) are 11% combined. Balanced 16% / end-loaded 80% of those bats.
  var SP_SHARE = [[25, 21], [26, 46], [27, 20], [28, 2]];

  function detectCert(title, type) {
    var t = (title + ' ' + type).toLowerCase();
    if (/bbcor/.test(t)) return 'bbcor';
    if (/fastpitch/.test(t)) return 'fastpitch';
    if (/fungo/.test(t)) return null;
    if (/slow ?pitch|senior softball/.test(t)) return 'slowpitch';
    if (/tee ?ball|t-ball/.test(t)) return 'teeball';
    if (/coach pitch/.test(t)) return 'coachpitch';
    if (/usssa/.test(t)) return 'usssa';
    if (/\busa\b/.test(t)) return 'usa';
    if (/\bwood\b|maple|birch|\bash\b|bamboo/.test(t)) return 'wood';
    return null;
  }

  function detectDrop(title, meta) {
    var m = String(meta || '').match(/-?\s?(\d{1,2}(?:\.5)?)/);
    if (m) return -Math.abs(parseFloat(m[1]));
    m = title.match(/-\s?(\d{1,2}(?:\.5)?)\s?(?:oz)?\b/i);
    return m ? -parseFloat(m[1]) : null;
  }

  // height rows: <=5'5", 5'6"-5'9", 5'10"-5'11", 6'0"-6'1", 6'2"-6'3", 6'4"+
  // weight cols: <=110, -120, -130, -140, -150, -160, -170, -180, -190, -200, 201+
  var HW_GRID = [
    [29, 30, 30, 31, 31, 31, 31, 32, 32, 32, 32],
    [29, 30, 31, 31, 32, 32, 32, 32, 33, 33, 33],
    [30, 31, 31, 32, 32, 32, 32, 33, 33, 33, 33],
    [31, 31, 32, 32, 33, 33, 33, 33, 33, 33, 33],
    [32, 32, 32, 33, 33, 33, 33, 33, 34, 34, 34],
    [32, 32, 33, 33, 33, 33, 34, 34, 34, 34, 34]
  ];

  function ftIn(h) { return Math.floor(h / 12) + "'" + (h % 12) + '"'; }

  // ---- Bat Genie sizing (ported from batreviews.com/bat-genie) ----
  // Slowpitch: every bat is 34", so the answer is WEIGHT — size + hitter type + preference
  // (Mike 9/1: "heavily on player preference", "more love to the 25oz"). Points: build ±1,
  // hitter ±1, feel ±1. Any single lean lighter → 25; neutral or one lean heavier → 26;
  // two → 27; all three → 28.
  function recSpWeight(A) {
    var pts = 0, h = A.height || 70, w = A.weight || 190;
    if (w <= 155 || h <= 66) pts -= 1; else if (w >= 215 || h >= 75) pts += 1;
    if (A.style === 'contact') pts -= 1; else if (A.style === 'power') pts += 1;
    if (A.feel === 'light') pts -= 1; else if (A.feel === 'heavy') pts += 1;
    return pts <= -1 ? 25 : pts <= 1 ? 26 : pts === 2 ? 27 : 28;
  }

  function recLength(cert, A) {
    var mode = CERTS[cert].mode, h = A.height || 0;
    if (mode === 'sp') return 34;
    if (mode === 'tee') return h <= 38 ? 24 : h <= 44 ? 25 : 26;
    if (mode === 'hw') {
      // BBCOR / adult wood: industry height x weight chart (Mike 9/1: "JustBats is right" for
      // BBCOR — e.g. 5'8" / 150 lb -> 32", not 33"). Rows = height, cols = weight bucket.
      var hi = h <= 65 ? 0 : h <= 69 ? 1 : h <= 71 ? 2 : h <= 73 ? 3 : h <= 75 ? 4 : 5;
      var w = A.weight || 0;
      var wi = w <= 110 ? 0 : w <= 120 ? 1 : w <= 130 ? 2 : w <= 140 ? 3 : w <= 150 ? 4 : w <= 160 ? 5 : w <= 170 ? 6 : w <= 180 ? 7 : w <= 190 ? 8 : w <= 200 ? 9 : 10;
      return HW_GRID[hi][wi];
    }
    // youth / fastpitch: AGE-anchored, height only nudges ±1" when clearly off-typical
    var a = A.age || 11;
    var aL = a <= 5 ? 25 : a === 6 ? 26 : a === 7 ? 27 : a === 8 ? 28 : a === 9 ? 29 : a <= 11 ? 30 : a <= 13 ? 31 : a === 14 ? 32 : 33;
    var typ = { 5: 43, 6: 45, 7: 48, 8: 50, 9: 52, 10: 54, 11: 56, 12: 58, 13: 60, 14: 63 }[a] || (a >= 15 ? (cert === 'fastpitch' ? 65 : 68) : 54);
    var adj = 0;
    if (h) {
      var d = h - typ, up = a <= 10 ? 9 : (a <= 12 ? 7 : 6);
      if (d >= up) adj = 1; else if (d <= -6) adj = -1;
    }
    if ((a === 11 || a === 12) && A.style === 'power' && adj < 1) adj = 1;
    var L = aL + adj;
    if (cert === 'fastpitch') L = Math.max(26, Math.min(34, L));
    else L = Math.max(24, Math.min(33, L));
    return L;
  }

  function recDrops(cert, A) {
    var mode = CERTS[cert].mode;
    if (cert === 'bbcor') return [-3];
    if (cert === 'wood') return [-3];
    if (mode === 'sp') return [];
    if (mode === 'tee') return [-10, -11, -12, -13];
    var a = A.age || 11, pwr = A.style === 'power';
    if (cert === 'fastpitch') {
      if (a <= 8) return [-12, -13, -11];
      if (a <= 10) return [-11, -12, -10];
      if (a <= 12) return [-10, -11, -9];
      if (a <= 14) return [-9, -10, -8];
      return [-8, -9, -10];
    }
    if (a <= 6) return [-12, -11, -10];
    if (a <= 8) return [-11, -10, -12];
    if (a <= 9) return [-10, -11];
    if (a <= 10) return [-10];
    if (a <= 11) return pwr ? [-8, -10] : [-10, -8];
    if (a <= 12) return pwr ? [-8, -10, -5] : [-10, -8];
    if (a <= 13) return [-8, -5];
    return [-5, -8];
  }

  // ---- variant picker helpers ----
  function sizeSelector() {
    var vp = document.querySelector('variant-picker');
    if (!vp) return null;
    return vp.querySelector('.option-selector[data-option="Size"], .option-selector[data-option="Length"], .option-selector[data-option="Bat Size"], .option-selector[data-option="Bat Length"]');
  }
  function parseLen(v) {
    var m = String(v).match(/^\s*(\d{2}(?:\.5)?)/);
    return m ? parseFloat(m[1]) : null;
  }
  function parseOz(v) {
    var m = String(v).match(/(\d{2}(?:\.5)?)\s*oz/i);
    return m ? parseFloat(m[1]) : null;
  }
  var KEY = parseLen; // switched to parseOz for slowpitch in boot()
  function isSecond(v) { return /floor model|demo|wrapper|blem|scuff|used|no warranty/i.test(v); }
  function variantsForLength(L) {
    var sel = sizeSelector(); if (!sel) return [];
    var out = [];
    sel.querySelectorAll('.js-option').forEach(function (inp) {
      if (KEY(inp.value) !== L) return;
      out.push({ input: inp, value: inp.value, available: !inp.classList.contains('is-unavailable'), second: isSecond(inp.value) });
    });
    out.sort(function (a, b) { return (a.second - b.second) || (b.available - a.available); });
    return out;
  }
  function selectVariant(inp) {
    var val = inp.value;
    inp.checked = true;
    inp.dispatchEvent(new Event('change', { bubbles: true }));
    // the theme re-renders the pills after a change — flash whichever label is current
    setTimeout(function () {
      var sel = sizeSelector(); if (!sel) return;
      sel.querySelectorAll('.js-option').forEach(function (i) {
        if (i.value !== val) return;
        var lab = sel.querySelector('label[for="' + i.id + '"]');
        if (lab) { lab.classList.add('cb-sg-flash'); setTimeout(function () { lab.classList.remove('cb-sg-flash'); }, 2200); }
      });
      // instant, and only if the picker is actually off-screen: iOS Safari can leave touch
      // scrolling of other overlays (e.g. the grip colour modal) stuck while a smooth
      // scrollIntoView is still animating (Mike, iPhone, 9/1).
      var r = sel.getBoundingClientRect();
      if (r.top < 0 || r.bottom > window.innerHeight) sel.scrollIntoView({ behavior: 'auto', block: 'center' });
    }, 350);
  }

  function boot() {
    var root = document.querySelector('[data-cb-sg]');
    if (!root || root.dataset.cbSgBooted) return;
    var cert = detectCert(root.dataset.title || '', root.dataset.type || '');
    if (!cert) return;
    var sel = sizeSelector();
    if (!sel) return;
    root.dataset.cbSgBooted = '1';

    var C = CERTS[cert];
    var drop = detectDrop(root.dataset.title || '', root.dataset.drop);
    if (C.mode === 'sp') KEY = parseOz;
    var allSizes = (root.dataset.sizes || '').split('|').map(KEY).filter(function (x) { return x != null; });
    function madeIn(L) { return allSizes.indexOf(L) !== -1; }
    var modal = root.querySelector('[data-cb-sg-modal]');
    var form = root.querySelector('[data-cb-sg-form]');
    var el = {
      sub: root.querySelector('[data-cb-sg-sub]'), len: root.querySelector('[data-cb-sg-len]'),
      up: root.querySelector('[data-cb-sg-up]'), down: root.querySelector('[data-cb-sg-down]'),
      drop: root.querySelector('[data-cb-sg-drop]'), actions: root.querySelector('[data-cb-sg-actions]'),
      result: root.querySelector('[data-cb-sg-result]')
    };
    el.sub.textContent = C.name + ' · ' + (root.dataset.title || '');
    if (C.mode === 'sp') {
      root.querySelector('#cb-sg-title').textContent = 'What Weight Should I Swing?';
      root.querySelector('.cb-sg-result__label').textContent = 'Recommended weight';
      root.querySelector('.cb-sg-result__fine').textContent = 'Every slowpitch bat is 34", so the choice is weight and load. Bigger, stronger power hitters carry more mass; contact hitters and anyone who values bat speed go lighter and balanced. There is no wrong answer here — swing what feels good. Check that the stamp (USSSA, USA/ASA, SSUSA Senior) matches your league.';
    }

    // ---- opener link beside the Size legend (re-checked after variant re-renders) ----
    function ensureLink() {
      var s = sizeSelector(); if (!s || s.querySelector('.cb-sg-open')) return;
      var legend = s.querySelector('legend.label, label.label'); if (!legend) return;
      var row = legend.parentElement;
      if (!row.classList.contains('cb-sg-row')) {
        row = document.createElement('div');
        row.className = 'flex items-baseline cb-sg-row';
        legend.parentNode.insertBefore(row, legend);
        row.appendChild(legend);
      }
      var btn = document.createElement('button');
      btn.type = 'button'; btn.className = 'link text-sm cb-sg-open'; btn.setAttribute('aria-haspopup', 'dialog');
      btn.textContent = 'What size do I need?';
      row.appendChild(btn);
      btn.addEventListener('click', open);
    }
    root._cbSgEnsure = ensureLink;
    ensureLink();

    // ---- inputs ----
    var A = { style: 'contact' }, touched = {};
    var need = (C.mode === 'hw' || C.mode === 'sp') ? ['height', 'weight'] : C.mode === 'hw' ? ['height', 'weight'] : C.mode === 'tee' ? ['height'] : ['age', 'height'];
    if (C.mode === 'sp') { A.style = 'none'; A.feel = 'none'; }
    var defaults = {
      age: cert === 'fastpitch' ? 12 : cert === 'coachpitch' ? 7 : cert === 'teeball' ? 5 : 10,
      height: (C.mode === 'hw' || C.mode === 'sp') ? 68 : cert === 'teeball' ? 42 : cert === 'coachpitch' ? 48 : 54,
      weight: C.mode === 'sp' ? 190 : 150
    };
    var ranges = {
      age: cert === 'fastpitch' ? [6, 18] : cert === 'coachpitch' ? [5, 9] : cert === 'teeball' ? [3, 7] : [5, 14],
      height: (C.mode === 'hw' || C.mode === 'sp') ? [54, 80] : cert === 'teeball' ? [34, 50] : [38, 74],
      weight: C.mode === 'sp' ? [110, 300] : [80, 260]
    };
    function fmt(k, v) {
      if (k === 'age') return (v >= ranges.age[1] && cert === 'fastpitch') ? v + '+ years old' : v + ' years old';
      if (k === 'height') return ftIn(v);
      if (k === 'weight') return (v >= ranges.weight[1] ? v + '+' : v) + ' lbs';
      return v;
    }
    var labels = { age: 'Player age', height: 'Player height', weight: 'Player weight' };
    var html = '';
    need.forEach(function (k) {
      if (!ranges[k]) return; // non-slider requirement (slowpitch hitter type)
      html += '<div class="cb-sg-slider" data-k="' + k + '">' +
        '<div class="cb-sg-slider__row"><span class="cb-sg-slider__label">' + labels[k] + '</span><output class="cb-sg-slider__out">Slide to set</output></div>' +
        '<input type="range" min="' + ranges[k][0] + '" max="' + ranges[k][1] + '" step="1" value="' + defaults[k] + '" aria-label="' + labels[k] + '"></div>';
    });
    if (C.mode === 'sp') {
      html += '<div class="cb-sg-style"><span class="cb-sg-slider__label">Type of hitter</span>' +
        '<div class="cb-sg-style__btns cb-sg-style__btns--3" role="group" aria-label="Type of hitter">' +
        '<button type="button" class="cb-sg-style__btn" data-style="contact"><strong>Contact / gaps</strong><span>line drives, place the ball</span></button>' +
        '<button type="button" class="cb-sg-style__btn is-on" data-style="none"><strong>No preference</strong><span>a bit of both</span></button>' +
        '<button type="button" class="cb-sg-style__btn" data-style="power"><strong>Power</strong><span>swinging for the fence</span></button></div></div>';
      html += '<div class="cb-sg-style"><span class="cb-sg-slider__label">What do you like a bat to feel like?</span>' +
        '<div class="cb-sg-style__btns cb-sg-style__btns--3" role="group" aria-label="Swing feel">' +
        '<button type="button" class="cb-sg-style__btn" data-feel="light"><strong>Quick &amp; light</strong></button>' +
        '<button type="button" class="cb-sg-style__btn is-on" data-feel="none"><strong>No preference</strong></button>' +
        '<button type="button" class="cb-sg-style__btn" data-feel="heavy"><strong>Heavy &amp; hot</strong></button></div></div>';
    }
    if (C.mode === 'youth') {
      html += '<div class="cb-sg-style"><span class="cb-sg-slider__label">Hitting style</span>' +
        '<div class="cb-sg-style__btns" role="group" aria-label="Hitting style">' +
        '<button type="button" class="cb-sg-style__btn is-on" data-style="contact"><strong>Contact</strong><span>bat control, line drives, most younger players</span></button>' +
        '<button type="button" class="cb-sg-style__btn" data-style="power"><strong>Power</strong><span>strong for their age, drives the ball</span></button></div></div>';
    }
    form.innerHTML = html;
    form.querySelectorAll('.cb-sg-slider').forEach(function (w) {
      var k = w.dataset.k, inp = w.querySelector('input'), out = w.querySelector('output');
      function upd(mark) { A[k] = +inp.value; out.textContent = fmt(k, +inp.value); if (mark) { touched[k] = true; w.classList.add('is-set'); } render(); }
      inp.addEventListener('input', function () { upd(true); });
      inp.addEventListener('change', function () { upd(true); });
      A[k] = +inp.value;
    });
    form.querySelectorAll('.cb-sg-style__btn').forEach(function (b) {
      b.addEventListener('click', function () {
        b.parentElement.querySelectorAll('.cb-sg-style__btn').forEach(function (x) { x.classList.toggle('is-on', x === b); });
        if (b.dataset.style) { A.style = b.dataset.style; touched.style = true; } else A.feel = b.dataset.feel;
        render();
      });
    });

    function dropTxt(d) { return d > 0 ? '-' + d : String(d); }
    function collUrl(L, drops) {
      if (C.mode === 'sp') return '/collections/' + C.coll + '?filter.v.m.custom.bat_weight=' + encodeURIComponent(L + ' oz');
      var u = '/collections/' + C.coll + '?filter.v.m.custom.bat_length=' + encodeURIComponent(L + '"');
      (drops || []).forEach(function (d) { u += '&filter.p.m.custom.drop=' + encodeURIComponent(dropTxt(d)); });
      return u;
    }

    function render() {
      var ready = need.every(function (k) { return touched[k]; });
      el.result.classList.toggle('is-ready', ready);
      if (!ready) {
        el.len.textContent = '—'; el.up.textContent = ''; el.down.textContent = '';
        el.drop.textContent = 'Set the sliders to see a recommendation.'; el.actions.innerHTML = '';
        return;
      }
      var L, drops = recDrops(cert, A);
      if (C.mode === 'sp') {
        L = recSpWeight(A);
        el.len.textContent = L + ' oz';
        el.down.textContent = L > 25 ? (L - 1) : ''; el.up.textContent = L < 28 ? (L + 1) : '';
        var loadTxt = A.style === 'contact' ? 'Balanced' : A.style === 'power' ? 'End-loaded' : 'Balanced or end-loaded';
        var bars = SP_SHARE.map(function (x) {
          return '<div class="cb-sg-bar' + (x[0] === L ? ' is-rec' : '') + '"><span class="cb-sg-bar__oz">' + x[0] + ' oz</span><span class="cb-sg-bar__track"><span class="cb-sg-bar__fill" style="width:' + (x[1] * 2) + '%"></span></span><span class="cb-sg-bar__pct">' + x[1] + '%</span></div>';
        }).join('');
        el.drop.innerHTML = '<strong>' + loadTxt + ', 34"</strong><span class="cb-sg-share"><span class="cb-sg-share__t">What CheapBats slowpitch customers buy</span>' + bars + '<span class="cb-sg-share__n">Half-ounce sizes are the other 11%. Weight is mostly preference &mdash; if you\'re between two, most players go 26.</span></span>';
        el.actions.innerHTML = actionsFor(L, [], false, L + ' oz');
        return;
      }
      L = recLength(cert, A);
      el.len.textContent = L + '"';
      el.down.textContent = L - 1; el.up.textContent = L + 1;
      // drop line
      var dTxt = drops.map(dropTxt);
      var dropLine = drops.length === 1 ? 'Drop: ' + dTxt[0] : 'Drop: ' + dTxt[0] + (dTxt.length > 1 ? ' (or ' + dTxt.slice(1).join(' / ') + ')' : '');
      var mismatch = drop != null && drops.indexOf(drop) === -1;
      el.drop.innerHTML = '<strong>' + dropLine + '</strong>' + (mismatch ? '<span class="cb-sg-result__warn">This bat is a ' + dropTxt(drop) + '. For this player we’d usually suggest ' + dTxt.join(' or ') + ' &mdash; a ' + dropTxt(drop) + ' will swing heavier.</span>' : '');
      el.actions.innerHTML = actionsFor(L, mismatch ? drops.slice(0, 2) : (drop != null ? [drop] : []), mismatch ? dTxt.slice(0, 2) : null, L + '"');
    }
    function actionsFor(L, linkDrops, mismatchTxt, label) {
      var vs = variantsForLength(L), avail = vs.filter(function (v) { return v.available; });
      var h = '';
      if (avail.length) {
        var v = avail[0];
        h += '<button type="button" class="btn btn--primary cb-sg-select" data-v="' + v.value.replace(/"/g, '&quot;') + '">Select ' + v.value.replace(/"/g, '&quot;') + ' on this bat</button>';
      } else if (vs.length || madeIn(L)) {
        h += '<div class="cb-sg-result__note">' + label + ' is sold out in this bat right now.</div>';
      } else {
        h += '<div class="cb-sg-result__note">This bat isn’t made in ' + label + '.</div>';
      }
      h += '<a class="link text-sm cb-sg-browse" href="' + collUrl(L, linkDrops) + '">See all ' + C.name + ' bats in ' + label + (mismatchTxt ? ' at ' + mismatchTxt.join(' / ') : '') + '</a>';
      setTimeout(function () {
        var sb = el.actions.querySelector('.cb-sg-select');
        if (sb) sb.addEventListener('click', function () {
          var match = variantsForLength(L).filter(function (v) { return v.value === sb.dataset.v; })[0];
          if (match) selectVariant(match.input);
          close();
        });
      }, 0);
      return h;
    }

    function open() {
      document.documentElement.classList.add('cb-sg-modal-open');
      if (typeof modal.showModal === 'function') modal.showModal(); else modal.setAttribute('open', '');
      render();
    }
    function close() {
      if (modal.open) modal.close(); else modal.removeAttribute('open');
      document.documentElement.classList.remove('cb-sg-modal-open');
    }
    root.querySelectorAll('[data-cb-sg-close]').forEach(function (b) { b.addEventListener('click', close); });
    modal.addEventListener('click', function (e) { if (e.target === modal) close(); });
    modal.addEventListener('close', function () { document.documentElement.classList.remove('cb-sg-modal-open'); });
    root.hidden = false;
    render();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('on:variant:change', function () {
    setTimeout(function () {
      var r = document.querySelector('[data-cb-sg]');
      if (r && r._cbSgEnsure) r._cbSgEnsure(); else boot();
    }, 50);
  });
})();
